import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Refer Link
  [types.GET_REFERRALS_LINK_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_REFERRALS_LINK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_REFERRALS_LINK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Create Refer Link
  [types.CREATE_REFERRALS_LINK_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.CREATE_REFERRALS_LINK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.CREATE_REFERRALS_LINK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATE_REFERRALS_LINK_RESET]: state => {
    const data = {
      ...state,
      errors_api: {}
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};